import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { HColor } from '@shared/src/datatypes/HColor';
import { FilterDto } from './FilterDtos';
import { FilterStripDto } from './FilterStripDtos';


@Component({
  selector: 'shared-filter',
  templateUrl: './shared.filter.component.html',
  styleUrls: ['./shared.filter.component.scss']
})
export class SharedFilterComponent {

  public useIonic: boolean = false;
  constructor(@Inject('HomeController') protected homecontroller: HomeController,
    protected translateService: TranslateService) {
    if (homecontroller.useIonic)
      this.useIonic = homecontroller.useIonic();
  }

  @Output() change = new EventEmitter<FilterDto>();

  private __filterStrip: FilterStripDto;
  @Input()
  public set filterstrip(value: FilterStripDto) {
    if (this.__filterStrip === value)
      return;

    this.__filterStrip = value;
    this.loadFilterStrip();
  }
  public get filterstrip(): FilterStripDto {
    return this.__filterStrip;
  }


  public list: Array<FilterDto>;
  private loadFilterStrip() {
    this.list = new Array();
    if (this.__filterStrip == null || this.__filterStrip.list == null) {
      return;
    }

    this.__filterStrip.list.forEach(element => {
      if (!this.showonlyactives || element.filterActive)
        this.list.push(element);
    });
  }

  private __refresh: any;
  @Input()
  public set refresh(value: any) {
    if (this.__refresh === value)
      return;
    this.__refresh = value;
    this.loadFilterStrip();

  }
  public get refresh(): any {
    return this.__refresh;
  }

  @Input()
  public externalClass: string = "";

  @Input()
  public applyColor: boolean = false;

  @Input()
  public readonly: boolean = false;

  private __showonlyactives: boolean = false;
  @Input()
  public set showonlyactives(value: boolean) {
    if (this.__showonlyactives === value)
      return;

    this.__showonlyactives = value;
    this.loadFilterStrip();
  }
  public get showonlyactives(): boolean {
    return this.__showonlyactives;
  }

  @Input() public balls: boolean = false;
  @Input() public maxVisible: number = 12;

  get visibleList(): FilterDto[] {
    if (!this.balls || !this.list) return this.list;
    return this.list.slice(0, this.maxVisible);
  }

  get hiddenList(): FilterDto[] {
    if (!this.balls || !this.list) return [];
    return this.list.length > this.maxVisible ? this.list.slice(this.maxVisible) : [];
  }

  get hiddenCount(): number {
    return this.hiddenList.length;
  }

  public toggleHidden: boolean = false;
  public searchTextFilter: string = "";
  public sliceCount: number = 3;


  toggleMenu() {
    this.toggleHidden = !this.toggleHidden;

    // calcular espacio necesario para mostrar las bolas
    const CHIP_HEIGHT = 48;
    const CHIP_GAP = 0;
    const SEARCH_HEIGHT = this.hiddenList && this.hiddenList.length > 3 ? 30 : 0;
    const MAX_MENU_HEIGHT = 250;

    let hiddenCount = this.hiddenList ? this.hiddenList.length : 0;
    if (hiddenCount > 3)
      hiddenCount = 3;
    let needed = SEARCH_HEIGHT + hiddenCount * (CHIP_HEIGHT + CHIP_GAP);
    if (needed > MAX_MENU_HEIGHT) needed = MAX_MENU_HEIGHT;

    this.toggleHiddenChange.emit({ open: this.toggleHidden, neededHeight: this.toggleHidden ? needed : 0 });
  }

  @Output() toggleHiddenChange = new EventEmitter<{ open: boolean, neededHeight: number }>();

  get filteredHiddenList(): FilterDto[] {
    if (!this.searchTextFilter) {
      return this.hiddenList.slice(0, this.sliceCount);
    }
    return this.hiddenList.filter(item =>
      item.filterCaption.toLowerCase().includes(this.searchTextFilter.toLowerCase())
    );
  }


  public getCaption(value: FilterDto) {
    return value.filterCaption;
  }

  public getClass(value: FilterDto) {
    let result = value.filterClass;
    if (value.filterActive)
      result += " active";
    return result;
  }

  public getStyle(value: FilterDto) {
    if (!this.applyColor)
      return {};

    let bcolor = HColor.getColorFromStringTable(this.translateService.instant(value.filterCaption), this.homecontroller);
    return {
      "color": HColor.getWhiteBlackFromColor(bcolor),
      "background-color": bcolor//,
      //"opacity": value.filterActive ? 1 : 0.5
    };
  }

  click(value: FilterDto) {
    if (this.readonly)
      return;

    if (value != null && this.__filterStrip != null && this.__filterStrip.toggle)
      this.__filterStrip.toggle(value);

    this.change.next(value);
  }

  public pretty(value: any): string {
    return JSON.stringify(value);
  }
}
